import React from "react";
import { Dialog } from "../../../../components/Dialogs/Dialog";
import { IPreviewComplaintProps } from "./interfaces/IPreviewComplaintProps";
import { Box, Button, Chip, Grid } from "@mui/material";
import { StandadCard } from "../../../../components/Cards";
import { StandardCellList } from "../../../../components/Standards";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../redux/initialStoreState";
import { formatDate, formatText } from "../../../../helpers";
import { CustomChip } from "../../../../components/CustomChip";

export const PreviewComplaint: React.FC<IPreviewComplaintProps> = (props) => {
  const { open, complaint, onClose, hideAssignedMechanicField = false } = props;

  const mechanics = useSelector(
    (storeState: IStoreState) => storeState.common.mechanics.list
  );
  const mechanic = mechanics.find(
    (x) => x.backoffice_users_id === complaint.assigned_mechanic_id
  );



  const handleDownload = (imageUrl: string) => {
    // Extract fileKey from URL, everything from uploads/ onwards
    const fileKeyMatch = imageUrl.match(/uploads\/.*/);
    const fileKey = fileKeyMatch ? fileKeyMatch[0] : "";

    if (fileKey) {
      const downloadUrl = `${process.env["REACT_APP_SERVER_URL"]}/download-docs?fileKey=${fileKey}`;
      // console.log(downloadUrl);
      window.open(downloadUrl, "_blank");
    }
  };

  return (
    <Dialog
      open={open}
      title="Complaint Full Details"
      onClose={onClose}
      size="md"
      actions={[
        { type: "button", label: "Close", variant: "text", onClick: onClose },
      ]}
    >
      <Grid container spacing={1}>
        <Grid item xs={12} lg={12}>
          <StandadCard heading="About Complaint" sx={{ mb: 2 }}>
            <StandardCellList
              colSize={4}
              list={[
                {
                  heading: "Complaint Number",
                  data: {
                    type: "text",
                    value: "# " + complaint?.complaint_no,
                  },
                },
                {
                  heading: "Name",
                  data: {
                    type: "text",
                    value: complaint?.name,
                  },
                },
                {
                  heading: "Complaint Type",
                  data: {
                    type: "text",
                    value: complaint?.paid_or_registered ? formatText(complaint.paid_or_registered) : "--",
                  },
                },
                {
                  heading: "Paid Complaint Custoemr Name",
                  data: {
                    type: "text",
                    value: complaint?.paid_complaint_username,
                  },
                },
                {
                  heading: "Membership Code",
                  data: {
                    type: "text",
                    value: complaint?.membership_code,
                  },
                },
                {
                  heading: "Partner Type",
                  data: {
                    type: "text",
                    value: complaint?.partner_type,
                  },
                },
                {
                  heading: "Partner Name",
                  data: {
                    type: "text",
                    value: complaint?.partner_name,
                  },
                },

                {
                  heading: "Fault Type",
                  data: {
                    type: "text",
                    value: complaint?.fault_type,
                    color: "error.main",
                  },
                },
                {
                  heading: "Fault Name",
                  data: {
                    type: "text",
                    value: complaint?.fault,
                    color: "error.main",
                  },
                },
                {
                  heading: "Sub Fault Type",
                  data: {
                    type: "text",
                    value: complaint?.sub_fault,
                    color: "error.main",
                  },
                },
                {
                  heading: "Complaint Date",
                  data: {
                    type: "text",
                    value: formatDate(complaint?.insert_dt),
                  },
                },
                {
                  heading: "Additional Address",
                  data: { type: "text", value: complaint?.complaint_address },
                },
                {
                  heading: "Stuck Location",
                  data: { type: "text", value: complaint?.stuckup_location },
                },
                {
                  heading: "Assigned Mechanic",
                  isHide: hideAssignedMechanicField,
                  data: {
                    type: "text",
                    value: complaint ? complaint?.mechnaic_name : "N/A",
                    color: complaint ? "success.main" : "error.main",
                  },
                },
                {
                  heading: "Assigned By",
                  isHide: hideAssignedMechanicField,
                  data: {
                    type: "text",
                    value: complaint ? complaint?.assigned_by_name : "N/A",
                    color: complaint ? "success.main" : "error.main",
                  },
                },
                {
                  heading: "Mechanic Type",
                  isHide: hideAssignedMechanicField,
                  data: {
                    type: "text",
                    value: complaint ? complaint?.mechanic_type : "N/A",
                    color: complaint.mechanic_type === "Regular" ? "success.main" : "error.main",
                  },
                },

                {
                  heading: "Service Type",
                  data: { type: "text", value: complaint?.service_type },
                },
                {
                  heading: "Service Amount",
                  data: {
                    type: "text",
                    value:
                      complaint?.service_type === "PAID"
                        ? complaint?.service_amount
                        : complaint?.amount,
                  },
                },
                {
                  heading: "Additional Amount",
                  data: {
                    type: "text",
                    value:
                      complaint?.additional_amount,
                  },
                },
                {
                  heading: "Additional Details",
                  data: {
                    type: "custom",
                    value: (
                      <div>
                        {complaint?.additional_details?.map((item: any, index: number) => {
                          const key = Object.keys(item)[0];
                          const detailValue = item[key];

                          const displayValue =
                            typeof detailValue === "object" && detailValue !== null
                              ? `${detailValue.value || ""} (₹${detailValue.amount || "0"})`
                              : String(detailValue);

                          return (
                            <React.Fragment key={index}>
                              {key.toUpperCase()}:{" "}
                              <CustomChip
                                color="success"
                                content={displayValue}
                                size="small"
                              />{" "}
                            </React.Fragment>
                          );
                        })}
                      </div>
                    ),
                  },
                },
                {
                  heading: "Complaint Creation Image",
                  data: {
                    type: "custom" as const,
                    value: (complaint?.complaint_creation_image || complaint?.complaint_creation_image_v) ? (
                      <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        onClick={() => handleDownload((complaint.complaint_creation_image || complaint.complaint_creation_image_v)!)}
                      >
                        Download Image
                      </Button>
                    ) : "--",
                  },
                }
              ]}
            />
          </StandadCard>
        </Grid>

        <Grid item xs={12} lg={6}>
          <StandadCard heading="vehicle Information" sx={{ mb: 2 }}>
            <StandardCellList
              colSize={6}
              list={[
                {
                  heading: "Vehicle Number",
                  data: {
                    type: "text",
                    value: complaint?.vehicle_number,
                  },
                },
                {
                  heading: "Type",
                  data: { type: "text", value: complaint?.vehicle_type },
                },
                {
                  heading: "Brand",
                  data: { type: "text", value: complaint?.vehicle_make },
                },

                {
                  heading: "Modal",
                  data: { type: "text", value: complaint?.vehicle_model },
                },
                {
                  heading: "Service City",
                  data: { type: "text", value: complaint?.service_city },
                },
                {
                  heading: "Vehicle Image",
                  data: {
                    type: "custom",
                    value: complaint?.complaint_vehicle_image ? (
                      <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        onClick={() => handleDownload(complaint.complaint_vehicle_image!)}
                      >
                        Download Image
                      </Button>
                    ) : "--",
                  },
                },
              ]}
            />
          </StandadCard>
        </Grid>
        <Grid item xs={12} lg={6}>
          <StandadCard heading="Closed Information" sx={{ mb: 2 }}>
            <StandardCellList
              colSize={6}
              list={[
                {
                  heading: "Service Status",
                  data: {
                    type: "text",
                    value: complaint?.service_status,
                  },
                },
                {
                  heading: "Service Status Reason",
                  data: {
                    type: "text",
                    value: complaint?.service_status_reason,
                  },
                },
                {
                  heading: "Complaint Status",
                  data: { type: "text", value: complaint?.status },
                },

                {
                  heading: "Amount To Mechanic",
                  data: { type: "text", value: complaint?.amount },
                },
                {
                  heading: "Additional Amount",
                  data: {
                    type: "text",
                    value:
                      complaint?.additional_amount,
                  },
                },
                {
                  heading: "Remark",
                  data: { type: "text", value: complaint?.remark },
                },

              ]}
            />
          </StandadCard>
        </Grid>
        <Grid item xs={12} lg={12}>
          <StandadCard heading="Additional Remark" sx={{ mb: 2 }}>
            <StandardCellList
              colSize={4}
              list={[
                {
                  heading: "Remarks",
                  data: {
                    type: "custom",
                    value: (complaint?.additional_remarks || complaint?.additional_remarks_v) ? (
                      <Box style={{ whiteSpace: "pre-wrap" }}>
                        {complaint?.additional_remarks || complaint?.additional_remarks_v}
                      </Box>
                    ) : "--",
                  },
                },
              ]}
            />
          </StandadCard>
        </Grid>
        <Grid item xs={12} lg={12}>
          <StandadCard heading="Additional Details" sx={{ mb: 2 }}>
            <StandardCellList
              colSize={6}
              list={complaint?.additional_details?.flatMap((item: any) =>
                Object.entries(item).map(([key, value]) => ({
                  heading: key,
                  data: { type: "text" as const, value: String(value) },
                }))
              ) || []}
            />
          </StandadCard>
        </Grid>
        <Grid item xs={12} lg={12}>
          <StandadCard heading="Contact Details" sx={{ mb: 2 }}>
            <StandardCellList
              colSize={4}
              list={[
                {
                  heading: "Registered Contact",
                  data: {
                    type: "text",
                    value: complaint?.reg_contact_no,
                  },
                },
                {
                  heading: "Alternative Contact",
                  data: { type: "text", value: complaint?.alternate_contact_no },
                },
                {
                  heading: "City",
                  data: { type: "text", value: complaint?.area },
                },
              ]}
            />
          </StandadCard>
        </Grid>
      </Grid>
    </Dialog>
  );
};
